import { Paragraph } from "@pebblepad/ckeditor";
import { EditorFactory } from "./EditorFactory";
import { EditorFactoryFunction } from "./types/EditorFactoryFunction";

export const multiLineFactory: EditorFactoryFunction = (editorContainer, toolbarContainer, editorPlaceholderContainer, content, onChange, config, onToolbarDisplayChange) => {
    return EditorFactory.create(editorContainer, toolbarContainer, editorPlaceholderContainer, content, onChange, config, [Paragraph], onToolbarDisplayChange);
};
